var _defs, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEsgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 109.86,
    y1: -209.2,
    x2: 99.98,
    y2: -250.33,
    gradientTransform: "matrix(1 0 0 -1 0 -91.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#606673",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373c47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 178.36,
    y1: -225.65,
    x2: 168.48,
    y2: -266.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 83.61,
    y1: -291.41,
    x2: 101.01,
    y2: -242.26,
    gradientTransform: "matrix(1 0 0 -1 0 -91.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c80aa",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5d6a86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 169.55,
    y1: -302.62,
    x2: 170.92,
    y2: -240.25,
    gradientTransform: "matrix(1 0 0 -1 0 -91.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#314f91",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#324264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 32.47,
    y1: -164.7,
    x2: 32.47,
    y2: -171.98,
    gradientTransform: "matrix(1 0 0 -1 0 -91.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b0bacc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969eae"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 42.34,
    y1: -277.42,
    x2: 42.34,
    y2: -284.7,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 239.8,
    y1: -272.81,
    x2: 235.31,
    y2: -281.71,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("style", null, "\n            .cls-5{fill:#eaeef9}.cls-6{fill:#edf1f9}.cls-10{fill:#dae2eb}.cls-11{fill:#dae1ed}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M218.41 91.78c4.33 0 7.85-3.52 7.85-7.85s-3.51-7.85-7.85-7.85-7.84 3.52-7.84 7.85 3.51 7.85 7.84 7.85ZM10 134.25c2.85 0 5.16-2.31 5.16-5.17s-2.31-5.17-5.16-5.17-5.16 2.31-5.16 5.17 2.31 5.17 5.16 5.17ZM33.73 227.13c2.85 0 5.16-2.31 5.16-5.17s-2.31-5.17-5.16-5.17-5.16 2.31-5.16 5.17 2.31 5.17 5.16 5.17Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m61.32 227.13 72.43-22.7v-93.06l-72.43 22.52v93.23Z",
    style: {
      fill: "#b7bfcd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.19 227.13-72.43-22.7v-93.06l72.43 22.52v93.23Z",
    style: {
      fill: "#6d7c9a",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.13
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m61.32 227.13 72.43-22.7v-93.06l-72.43 22.52v93.23Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.19 227.13-72.43-22.7v-93.06l72.43 22.52v93.23Z",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m133.76 250-72.43-22.7v-93.06l72.43 22.7V250Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m133.75 250 72.43-22.7v-93.06l-72.43 22.7V250Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m117.34 233.59-56.02-6.29v-93.06l72.43 22.7-16.41 76.65Z",
    style: {
      fill: "url(#linear-gradient-3)",
      opacity: 0.09,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.17 217.18 56.02 10.13v-93.06l-72.43 22.7 16.41 60.23Z",
    style: {
      isolation: "isolate",
      fill: "url(#linear-gradient-4)",
      opacity: 0.2
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M133.75 111.37 99.69 85.88l-73.65 24.79 35.27 23.22 72.43-22.52ZM133.75 111.37l34.06-25.49 73.65 24.79-35.27 23.22-72.43-22.52Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m61.32 134.25 72.43 22.7L97.62 180l-71.57-23.74 35.27-22Z",
    style: {
      fill: "#eff4fd"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m206.19 134.25-72.43 22.7L169.89 180l71.57-23.74-35.27-22Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M153.96 22.04c10.15 27.54 13.17 33.66 14.17 60.8-.38 6.19-.62 12.93-3.54 18.35-3.9 8.3-13.44 14.04-22.45 14.14-9.28.17-18.39-5.52-22.48-14.28-2.88-5.32-2.79-12.6 1.16-17.43 4.3-4.63 11.86-5.79 17.3-2.89 5.98 2.75 9.56 8.46 10.88 14.49 1.32 6.03.74 12.57-.87 18.51-3.38 14.46-6.17 15.16-14.46 39.63",
    style: {
      fill: "none",
      stroke: "#abb5cc",
      strokeDasharray: "0 0 4 4",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M166.32 7.46c-.02 4.05-3.79 6.53-8.57 5.24-5.03-.86-8.59-1.74-8.82-5.36.12-3.71 4.16-5.16 8.89-6.79 5.68-2.26 8.18 2.96 8.5 6.91ZM133.8 19.84c2.55 2.63 7.93 3.39 10.55-.62 2.87-4.45 5.33-7.68 2.69-10.64-2.55-2.63-5.03-.86-10.71 1.4-4.55 2.32-5.52 6.99-2.53 9.87Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M145.57 3.09c2.32-.99 5.1-.26 6.34 1.61.53.59 1.15 1.53 1.33 2.22 1.98 4.62 1.35 9.19-1.31 10.28-2.92 1.52-6.94-1.08-8.48-5.45-.37-1.37-.55-2.06-.83-3.09-.3-2.49.62-4.58 2.94-5.57.34-.09 0 0 0 0Z",
    style: {
      fill: "#989fb0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.89 77.41H34.4v-4.49h-3.85v4.49h-4.49v3.98h4.49v4.49h3.85v-4.49h4.49v-3.98Z",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.76 190.13h-4.49v-4.49h-3.85v4.49h-4.49v3.98h4.49v4.49h3.85v-4.49h4.49v-3.98Z",
    style: {
      fill: "url(#linear-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.16 190.39-5.5-2.78 2.78-5.5-4.71-2.38-2.78 5.5-5.5-2.78-2.46 4.87 5.5 2.78-2.78 5.5 4.71 2.38 2.78-5.5 5.5 2.78 2.46-4.87Z",
    style: {
      fill: "url(#linear-gradient-7)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsgEmpty);
export default __webpack_public_path__ + "static/media/esg_empty.dcec3c1e087c6c13c67054fd75521397.svg";
export { ForwardRef as ReactComponent };